import { ProductPlusPromotion } from '@features/add-to-cart-page/typings/Product';

export enum SummaryItemPaymentType {
  Monthly = 'monthly',
  OneTime = 'one-time'
}

export enum SummaryItemType {
  Accessory = 'accessory',
  Insurance = 'insurance',
  Service = 'service',
  ExtendedWarranty = 'extended-warranty',
  FreeWith = 'free-with',
  Promotion = 'promotion',
  CrossSellCharger = 'cross-sell-charger'
}

export type ListPrice = {
  includingVat: number;
  excludingVat?: number;
};

export enum PromotionType {
  FreeWith = 'FreeWith',
  Norton = 'Norton',
  Nespresso = 'Nespresso'
}

export type PersonalPrice = {
  price: {
    includingVat: number;
    excludingVat?: number;
  };
  labelText: string;
};

export type SummaryItem = {
  brand?: { name: string };
  id?: number | string;
  name: string;
  quantity: number;
  salesPrice: {
    includingVat: number;
    excludingVat?: number;
  };
  personalPrice?: PersonalPrice;
  listPrice?: ListPrice;
  paymentType: SummaryItemPaymentType;
  promotion?: ProductPlusPromotion;
  showPrice: boolean;
  shortName?: string | null;
  type: SummaryItemType;
};
